import { useTranslation } from 'libs/i18n';
import { Section } from 'modules/client/common/components';

import { FormContent } from './FormContent';

export const CompanyBusinessRelationshipSection = () => {
  const { t } = useTranslation();

  return (
    <Section
      datax="companyBusinessRelationshipSection"
      title={t('client.legal.companyBusinessRelationship.title')}
    >
      <FormContent />
    </Section>
  );
};
